import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LicenseService } from 'app/core/services/license.service';
import { RxComponent } from 'app/shared/components/common/rx.component';
import { LoadingPage } from 'app/shared/components/loading/loading.page.component';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { CardConfiguration } from 'app/core/components/workflow-new/course/configurations/card-configuration';
import { CardConfigurationService } from 'app/core/components/workflow-new/course/configurations/card-configuration.service';
import { CommBoxConfig } from 'app/core/components/workflow-new/common/communication-box/communication-box.component';
import { DomainService } from 'app/core/services/domain.service';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

@Component({
  selector: 'itpx-course-container',
  templateUrl: './course-container.component.html',
  styleUrls: ['./course-container.component.css', '../../common/style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CourseContainerComponent extends LoadingPage implements OnInit {
  // private backgroundUrl: string = 'https://itpx-branded-portal-dev.s3.amazonaws.com/course-background.png';
  private backgroundUrl$: Observable<string>;
  private classConfig: CardConfiguration;
  private platformClass: any;
  private tab: string;
  private readonly emptyConfig: CommBoxConfig = {
    message: 'branded.portal.courses.assignment.empty.message',
    actions: [{title: 'Redeem Voucher', style: 'btn btn-light', link: ['/app','redeem']}],
    domain: this.domainService.getDomain(),
    level: 'info'
  }
  private learnerCertificates$= new ReplaySubject<any[]>(1);

  constructor(
    private route: ActivatedRoute,
    private licenseService: LicenseService,
    private cardConfiguration: CardConfigurationService,
    private domainService: DomainService,
    private detector: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.backgroundUrl$ = this.domainService.getBanner();
    this.tab = 'content';
    this.route.params
      .flatMap(params => this.licenseService.getUpdatedClassAssignments(params['id']))
      .map(body => body.data)
      .cacheResult()
      .subscribe(res => {
        console.log(res);
        this.platformClass = res;
        this.classConfig = this.cardConfiguration.getBannerConf(this.platformClass);
        this.classConfig.hideInstructor = false;
        this.classConfig.hideLocation = false;
        this.classConfig.hideStatus = true;
        this.learnerCertificates$.next(this.platformClass.learnerCertificates.map(v => { v.status = 'upToDate'; return v; }));
        this.ready();
        this.detector.detectChanges();
      });
  }

  getType(course: any) {
    let c = this.cardConfiguration.getConf(course);
    c.cardWidth = '960';
    return c;
  }

  onTabClicked(tab: string) {
    if (tab === 'achievements' && 0 === this.platformClass.learnerCertificates.length)
      return;
    this.tab = tab;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/course/course-container/course-container.component.ts